import React from 'react';
import { FC, memo } from 'react';
import { Link } from '@mui/material';
import { useTransition, animated } from '@react-spring/web';
import styled from 'styled-components';

import { ReportLpFile } from './index';
import { List } from './styles';
import { fluidPadding } from '../../utils/styles';

interface Props {
  files: ReportLpFile[];
  open: boolean;
}

const FileList: FC<Props> = memo(({ files, open }) => {
  const transitions = useTransition(open, {
    config: { mass: 1, tension: 5000, friction: 250 },
    from: { opacity: 0, height: 0 },
    enter: { opacity: 1, height: 'auto' },
    leave: { opacity: 0, height: 0 },
  });

  return (
    <Wrapper>
      {transitions(
        (animation, item, { key }) =>
          item && (
            <animated.div key={key} style={animation}>
              {files.map(file => (
                <List key={crypto.randomUUID()}>
                  <li>{file.filename}</li>
                  <li>{file.date}</li>
                  <li>
                    <Link href={file.path} underline="hover" download>download</Link>
                  </li>
                </List>
              ))}
            </animated.div>
          )
      )}
    </Wrapper>
  );
});

const Wrapper = styled.div`
  ${fluidPadding}
`;

export default FileList;
